export default "__VITE_ASSET__aebe9cfa__"